import { useContext } from "react"
import { func } from "prop-types"
import RegisterableContext from "components/admin/registerable/context"
import { StackView } from "@planningcenter/tapestry-react"
import SelectionGroup from "./SelectionGroup"
import SignupTime from "./SignupTime"

const SignupTimeSelections = ({ onSelectionsChange }) => {
  const {
    registerable: { event, attendeeTypeSelections }
  } = useContext(RegisterableContext)

  return (
    <StackView>
      {event.eventTimes.map(({ id, name }) => {
        const signupTimeSelections = attendeeTypeSelections.filter(
          ({ signupTimeId }) => signupTimeId == id
        )

        return (
          <SignupTime
            key={id}
            id={id}
            name={name}
            selected={signupTimeSelections.some(({ count }) => count > 0)}
            onSelectionsChange={onSelectionsChange}
            className="signupTimeWrapper"
          >
            <StackView spacing={1}>
              <SelectionGroup
                onSelectionsChange={onSelectionsChange}
                selections={signupTimeSelections}
                className="selectionGroupWithSplitTimes"
              />
            </StackView>
          </SignupTime>
        )
      })}
    </StackView>
  )
}

SignupTimeSelections.propTypes = {
  onSelectionsChange: func.isRequired
}

export default SignupTimeSelections
